
import { formatNumber, formatDate } from '../../lib/filters'
import { defineComponent, watch, computed, ref } from 'vue'
import { objectResolve } from '@/lib/common'

export default defineComponent({
  props: {
    searchEnabled: { type: Boolean, default: true },
    sortEnabled: { type: Boolean, default: true },
    infoEnabled: { type: Boolean, default: true },
    columns: { type: Array, required: true },
    data: {} as any,
    rowComponent: { default: null },
    bodyComponent: { default: null },
    outerPageNumber: { default: 1 },
    rowStyleList: { type: Array, default: null }
  },
  emits: ['page-filter-change', 'row-click'],
  setup(props, ctx) {
    const currentPageNum = ref(props.outerPageNumber - 1)
    const lastSort = ref({ field: '', direction: '', ico: '' })
    const search = ref('')
    const searchNoResults = ref(false)

    const visibleColumns = computed(() => props.columns.filter((x: any) => !x.hidden))
    const pageFilter = computed(() => ({ page: currentPageNum.value + 1, sort: lastSort.value.field ? lastSort.value.field + ' ' + lastSort.value.direction : null }))
    const pageCount = computed(() => props.data.pageCount)
    const pageSize = computed(() => props.data.pagerPageSize)
    const recordCount = computed(() => props.data.recordCount)
    const info = computed(() => {
      if (!props.data.data) {
        return
      }
      let info = ''
      const length = props.data.data.length
      const f = length > 0 ? currentPageNum.value * pageSize.value + 1 : 0
      let t = (currentPageNum.value + 1) * pageSize.value
      if (t > recordCount.value) {
        t = recordCount.value
      }

      if (search.value !== '') {
        info = `Prikazanih ${formatNumber(f, 0)} - ${formatNumber(t, 0)} od ${formatNumber(length, 0)} najdenih zapisov (od vseh ${formatNumber(recordCount.value, 0)} zapisov)`
      } else {
        info = `Prikazanih ${formatNumber(f, 0)} - ${formatNumber(t, 0)} od ${formatNumber(recordCount.value, 0)} zapisov`
      }
      return info
    })
    const pages = computed(() => {
      const p = []
      const cp = currentPageNum.value + 1
      const np = pageCount.value
      if (cp - 2 > 0) {
        if (cp > 3) {
          p.push(1)
          if (cp > 4) {
            p.push('...')
          }
        }
        for (let i = cp - 2; i < cp + 3 && i + 1 < np; i++) {
          p.push(i)
        }
      } else {
        p.push(1)
        p.push(2)
        p.push(3)
        p.push(4)
      }
      if (cp + 3 < np) {
        p.push('...')
      } else {
        p.push(np - 1)
      }
      p.push(np)
      return p
    })

    const sortData = (col: any) => {
      let direction = 'asc'
      if (col.dbField === lastSort.value.field) {
        direction = lastSort.value.direction === 'asc' ? 'desc' : 'asc'
      }
      lastSort.value.field = col.dbField
      lastSort.value.direction = direction
      lastSort.value.ico = direction === 'desc' ? '↓' : '↑'
      ctx.emit('page-filter-change', pageFilter.value)
    }

    const getColCaption = (col: any) => {
      let cap = col.caption
      if (col.dbField === lastSort.value.field) {
        cap += ' ' + lastSort.value.ico
      }
      return cap
    }

    const getColValue = (col: any, data: any) => {
      let val = data[col.field]
      if (col.field.indexOf('.') > 0) {
        val = objectResolve(col.field, data)
      }
      if (col.template) {
        return col.template
      } else if (col.format) {
        switch (col.format.type) {
          case 'date':
            return val ? formatDate(val, col.format.format) : ''
          case 'number':
            return formatNumber(val, Number(col.format.format))
          case 'currency':
            return formatNumber(val, Number(col.format.format)) + ' €'
          case 'yesno':
            if (val === true) {
              return 'DA'
            } else if (val === false) {
              return 'NE'
            } else {
              return val
            }
          case 'yesnonp':
            if (val === true) {
              return 'DA'
            } else if (val === false) {
              return 'NE'
            } else {
              return 'N.P.'
            }
        }
      }
      return val
    }

    const rowStyle = (data: any) => {
      let css = ''
      if (props.rowStyleList?.length > 0) {
        props.rowStyleList.forEach((x: any) => {
          const c = Object.keys(x)[0]
          let applyStyle = false
          if (typeof x[c] === 'function') {
            applyStyle = x[c](data)
          } else if (eval('data.' + x[c])) {
            applyStyle = true
          }
          if (applyStyle) {
            css += c + ' '
          }
        })
      }
      return css
    }

    watch(currentPageNum, () => ctx.emit('page-filter-change', pageFilter.value))
    watch(
      () => props.outerPageNumber,
      (val) => {
        currentPageNum.value = val - 1
      }
    )
    return { currentPageNum, lastSort, search, searchNoResults, visibleColumns, pageFilter, pageCount, pageSize, recordCount, info, pages, sortData, getColCaption, getColValue, rowStyle }
  }
})
